export const APP_URL = process.env.REACT_APP_URL ?? "https://guppyweb.thinkbar.tech";
export const APP_SERVER_URL = process.env.REACT_APP_SERVER_URL ?? "https://manage.guppytheatre.com";